import { useHeroMotion } from '../hooks/useHeroMotion';
import { HeroBackdrop } from './hero/HeroBackdrop';
import { HeroContent } from './hero/HeroContent';
import { HeroScrollButton } from './hero/HeroScrollButton';

const Hero = () => {
  const { ref, onMouseMove, scrollY } = useHeroMotion();
  return (
    <section data-testid="home-hero" ref={ref} onMouseMove={onMouseMove} className="relative w-full h-screen min-h-[680px] overflow-hidden" style={{ '--x': '50%', '--y': '50%' }}>
      <HeroBackdrop scrollY={scrollY} />
      <HeroContent scrollY={scrollY} />
      <HeroScrollButton />
    </section>
  );
};

export default Hero;